import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ArrowCarrotUpAndDownIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M8.743 14h6.516c.957 0 1.217.577.57 1.29l-3.154 3.468a.89.89 0 01-1.348 0L8.173 15.29c-.646-.712-.392-1.29.57-1.29zm6.515-4H8.742c-.957 0-1.217-.577-.57-1.29l3.154-3.468a.89.89 0 011.348 0l3.154 3.468c.646.712.392 1.29-.57 1.29z"
                        }),
                        _jsx("use", {
                            transform: "rotate(180 12 12)"
                        })
                    ]
                })
            })
        ]
    });
};
ArrowCarrotUpAndDownIcon.isCarinaIcon = true;
export default ArrowCarrotUpAndDownIcon;
